var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 40C22.4 38.7333 20.6667 37.75 18.8 37.05C16.9333 36.35 15 36 13 36C11.6 36 10.225 36.1833 8.875 36.55C7.525 36.9167 6.23333 37.4333 5 38.1C4.3 38.4667 3.625 38.45 2.975 38.05C2.325 37.65 2 37.0667 2 36.3V12.2C2 11.8333 2.09167 11.4833 2.275 11.15C2.45833 10.8167 2.73333 10.5667 3.1 10.4C4.63333 9.6 6.23333 9 7.9 8.6C9.56667 8.2 11.2667 8 13 8C14.9333 8 16.825 8.25 18.675 8.75C20.525 9.25 22.3 10 24 11V36.3C25.7 35.2 27.4833 34.375 29.35 33.825C31.2167 33.275 33.1 33 35 33C36.2 33 37.5083 33.1167 38.925 33.35C40.3417 33.5833 41.7 34.0667 43 34.8V9.55C43.3295 9.675 43.6536 9.80625 43.9721 9.94375C44.2907 10.0813 44.6 10.2333 44.9 10.4C45.2333 10.6 45.5 10.8613 45.7 11.1839C45.9 11.5065 46 11.8452 46 12.2V36.3C46 37.0667 45.675 37.65 45.025 38.05C44.375 38.45 43.7 38.4667 43 38.1C41.7667 37.4333 40.475 36.9167 39.125 36.55C37.775 36.1833 36.4 36 35 36C33 36 31.0667 36.35 29.2 37.05C27.3333 37.75 25.6 38.7333 24 40ZM27 31.65V14L40 1V20.35L27 31.65ZM21 34.8V12.85C19.8667 12.2167 18.55 11.75 17.05 11.45C15.55 11.15 14.2 11 13 11C11.4333 11 9.975 11.1667 8.625 11.5C7.275 11.8333 6.06667 12.2589 5 12.7767V34.8C6.16667 34.2333 7.425 33.7917 8.775 33.475C10.125 33.1583 11.5417 33 13.025 33C14.5083 33 15.9167 33.1583 17.25 33.475C18.5833 33.7917 19.8333 34.2333 21 34.8Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.7323abf00cab7da6cc66974d5a433091.svg";
export { ForwardRef as ReactComponent };